/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllSplunk, getAllSplunkUsers, getSplunkHistory, getSplunkRecord } from './splunkAction';

const initialState = {
    data: {},
    splunkList: {},
    splunkHistory: {},
    splunkInfo: {},
    splunkUsersList: {}

}
const splunkSlice = createSlice({
    name: 'splunk',
    initialState,
    extraReducers: {
        [getAllSplunkUsers.fulfilled]: (state, { payload }) => {
            state.splunkUsersList = payload;
        },
        [getAllSplunk.fulfilled]: (state, { payload }) => {
            state.splunkList = payload;
        },
        [getAllSplunk.rejected]: (state, { payload }) => {
            state.splunkList = {};
        },
        [getSplunkRecord.fulfilled]: (state, { payload }) => {
            state.splunkInfo = payload;
        },
        [getSplunkRecord.rejected]: (state, { payload }) => {
            state.splunkInfo = {};
        },
        [getSplunkHistory.fulfilled]: (state, { payload }) => {
            state.splunkHistory = payload;
        },
        [getSplunkHistory.rejected]: (state, { payload }) => {
            state.splunkHistory = {};
        },
    }
});

export default splunkSlice.reducer